export default function colorFromNm(nm: number | undefined) {
  if (!nm || nm > 580) return '#ff3311';
  if (nm > 480) return '#98d700';
  if (nm > 380) return '#0a87db';
  return '#9c11ff';
}
